(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.glow.component'

  require('angular')
    .module(MODULE_NAME, [
      require('angular-aria'),
      require('../../sdk-config'),
      require('../glow-config'),
      require('./glow-cart'),
      require('./glow-vote'),
      require('./glow-page'),
      require('./glow-module')
    ])

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/component/index.js